import { createFileRoute } from '@tanstack/react-router';
import Employees from '@/features/employees';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/employees')({
  component: EmployeesRoute,
});

function EmployeesRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.EmployeeView}>
      <Employees />
    </ProtectedRoute>
  );
} 